<h2 class="group-title">{{config.label}}</h2>
<ng-container *ngFor="let field of config.children" otDynamicField [config]="field" [rootGroup]="rootGroup"
              [group]="group.get(config.field)" [errors]="errors" otDynamicCondition></ng-container>
